@if (!formLoaded) {
  <div class="spinner-pos">
    <div class="margin-auto">
      <mat-spinner [diameter]="24"></mat-spinner>
    </div>
  </div>
} @else {
  <div class="carrier-form">
    <div mat-dialog-content class="carrier-form__content">
      <div class="carrier-provider-section__providers">
        <span
          class="carrier-form__logo-container"
          fxLayout="column"
          fxLayoutAlign="center center"
          fxLayoutGap="1px"
          fxLayoutGap.xs="0">
          <div class="carrier-form__logo-image">
            <carrier-logo [carrierName]="carrierType?.name"></carrier-logo>
          </div>
          <p class="carrier-form__logo-text">{{ carrierDisplayName }}</p>
        </span>
        @if (isTestModeSupported) {
          <div class="carrier-provider-section__providers">
            @if (toolTipLabelOnTestMode) {
              <span class="carrier-provider-section__providers-title">
                Test mode
                <img
                  src="assets/icons/icon-info.svg"
                  class="form-title-info-icon"
                  matTooltip="Activate billing plan in order to enable production mode"
                  matTooltipClass="pdq-mat-tooltip"
              /></span>
            }
            <pdq-slide-toggle
              [defaultValue]="!!defaultValues?.isTestMode"
              [control]="formGroup?.controls?.isTestMode"
              (onToggle)="onIsTestModeToggle()"></pdq-slide-toggle>
          </div>
        }
      </div>
      <form class="carrier-form__form" [formGroup]="formGroup" (submit)="onSubmit()" autocomplete="off">
        @if (carrierConfigDataLoaded && carrierFields.defaultFields) {
          @if (isMultiMerchantShop) {
            <div class="additional-fields">
              <pdq-dropdown
                [defaultOption]="eCommerceSubTenants | eCommerceSubTenantsOptions: defaultValues?.eCommerceSubTenants"
                (onMultiSelectOptionChecked)="subTenantsSelectHandler($event)"
                selectBy="checked"
                title="Merchants"
                multiSelect="true"
                placeholder="Select merchants"
                [options]="
                  eCommerceSubTenants | eCommerceSubTenantsOptions: defaultValues?.eCommerceSubTenants
                "></pdq-dropdown>
            </div>
          }
          @for (fieldConfig of carrierFields.defaultFields; track fieldConfig) {
            @if (!checkIsHiddenField(fieldConfig)) {
              <div class="form-control">
                <div fxLayout="col" class="form-control-title-div">
                  <div class="form-title">{{ fieldConfig.displayName }}</div>
                  @if (fieldConfig.descriptionText) {
                    <div>
                      <img
                        src="assets/icons/icon-info.svg"
                        class="form-title-info-icon"
                        matTooltip="{{ fieldConfig.descriptionText }}"
                        matTooltipClass="pdq-mat-tooltip" />
                    </div>
                  }
                </div>
                <app-carrier-form-field
                  [fieldConfig]="fieldConfig"
                  [carrierOperationMode]="carrierOperationMode"
                  [control]="formGroup.controls[fieldConfig.fieldName]"
                  [formSubmitAttempt]="formSubmitAttempt"
                  [isReadOnly]="isDefaultFieldReadonly(fieldConfig)">
                </app-carrier-form-field>
              </div>
            }
          }
        }
        @if (carrierConfigDataLoaded && carrierFields.metaDataFields) {
          <div class="carrier-meta-data">
            @for (metaFieldConfig of carrierFields.metaDataFields; track metaFieldConfig; let i = $index) {
              @if (
                !checkIsHiddenField(metaFieldConfig) &&
                isEnableOnlyInEditMode(metaFieldConfig) &&
                (!metaFieldConfig.dependentField ||
                  isFieldEnabled(metaFieldConfig.dependentField, metaFieldConfig.dependentFieldValue))
              ) {
                <div
                  class="form-control"
                  [ngClass]="{ 'form-control__full-row': metaFieldConfig.displaySettings?.fullWidth }">
                  <div fxLayout="row">
                    <div class="form-title">{{ metaFieldConfig.displayName }}</div>
                    @if (metaFieldConfig.descriptionText) {
                      <div>
                        <img
                          src="assets/icons/icon-info.svg"
                          class="form-title-info-icon"
                          matTooltip="{{ metaFieldConfig.descriptionText }}"
                          matTooltipClass="pdq-mat-tooltip" />
                      </div>
                    }
                  </div>
                  @if (
                    !checkIsHiddenField(metaFieldConfig) &&
                    isEnableOnlyInEditMode(metaFieldConfig) &&
                    (!metaFieldConfig.dependentField ||
                      isFieldEnabled(metaFieldConfig.dependentField, metaFieldConfig.dependentFieldValue))
                  ) {
                    <app-carrier-form-field
                      [isMetaField]="true"
                      [fieldConfig]="metaFieldConfig"
                      [carrierOperationMode]="carrierOperationMode"
                      [formGroup]="formGroup"
                      [control]="formGroup.controls[metaFieldConfig.fieldName]"
                      [formSubmitAttempt]="formSubmitAttempt"
                      [isReadOnly]="isMetaFieldReadonly(metaFieldConfig)">
                    </app-carrier-form-field>
                  }
                </div>
              }
            }
          </div>
        }
        @if (carrierConfigDataLoaded && this.providersFormArray?.controls?.length > 0) {
          <div class="form-control">
            <span class="carrier-provider-section__providers-title">
              Your {{ checkIsMasterCarrier() ? '' : carrierDisplayName }} carriers
            </span>
            @for (providerConfig of this.providersFormArray.value; track providerConfig; let i = $index) {
              <div>
                <div class="carrier-provider-section">
                  <div class="carrier-provider-section__providers">
                    <!-- provider left arrow -->
                    @if (providerConfig.providerServices?.length) {
                      <div class="arrow-icon" (click)="onArrowClick($event, i)">
                        <img
                          class="arrow-icon__img"
                          [ngClass]="{ open: arrowFunctionArray && arrowFunctionArray[i] }"
                          src="assets/icons/chevron_down.svg"
                          alt="" />
                      </div>
                    }
                    <carrier-logo [carrierName]="getFormattedCarrierName(providerConfig)" size="small"></carrier-logo>
                    <!-- provider toggle -->
                    <div class="carrier-provider-section__title">
                      {{ getProviderDisplayNameMap(providerConfig.name) || providerConfig.name }}
                    </div>
                    <pdq-slide-toggle
                      (onToggle)="onProviderEnableChange($event, providerConfig)"
                      [defaultValue]="providerConfig.enabled">
                    </pdq-slide-toggle>
                  </div>
                  <!-- provider services -->
                  @if (arrowFunctionArray && arrowFunctionArray[i]) {
                    <div class="carrier-provider-section__service-levels">
                      @for (
                        providerServicesConfig of this.providersFormArray.controls[i].value.providerServices;
                        track providerServicesConfig;
                        let j = $index
                      ) {
                        <div class="checkbox-control">
                          <pdq-checkbox
                            [checked]="providerServicesConfig.enabled"
                            (onChange)="onProviderServicesEnableChange($event, providerServicesConfig)"
                            label="{{ providerServicesConfig.displayName }}">
                          </pdq-checkbox>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </form>
    </div>
  </div>
}
